import { Fragment } from 'react';
import { s } from '../lib/style.js';

export function ToolMarquee({ v }) {
  return (
    <section
      style={s("border-top:1px solid var(--line);border-bottom:1px solid var(--line);background:var(--panel);overflow:hidden;padding:34px 0 30px;")}
    >
      <div
        style={s("font-family:var(--mono);font-weight:var(--mono-w);font-size:12.5px;letter-spacing:0.2em;text-transform:uppercase;color:var(--muted);text-align:center;opacity:.72;margin-bottom:26px;")}
      >
        Supports all major tools and platforms
      </div>
      <div
        style={s("overflow:hidden;-webkit-mask-image:linear-gradient(90deg,transparent 0,#000 10%,#000 90%,transparent 100%);mask-image:linear-gradient(90deg,transparent 0,#000 10%,#000 90%,transparent 100%);")}
      >
        <div style={s("display:flex;width:max-content;animation:bb-marquee 38s linear infinite;")}>
          <div style={s("display:flex;align-items:center;gap:52px;padding-right:52px;")}>
            {(v.connectors ?? []).map((c, i) => (
              <Fragment key={i}>
                {' '}
                <span
                  style={s("display:inline-flex;align-items:center;gap:11px;white-space:nowrap;opacity:.55;filter:grayscale(1);")}
                >
                  {c.logo ? (
                    <>
                      {' '}
                      <span
                        style={s(`width:22px;height:22px;background:url(${c.logo ?? ""}) center/contain no-repeat;flex:0 0 auto;`)}
                      />
                      {' '}
                    </>
                  ) : null}
                  {' '}
                  <span
                    style={s("font-family:'Sofia Pro',sans-serif;font-size:20px;font-weight:700;letter-spacing:-0.02em;color:var(--text);")}
                  >
                    {c.name}
                  </span>
                  {' '}
                </span>
                {' '}
              </Fragment>
            ))}
          </div>
          <div aria-hidden="true" style={s("display:flex;align-items:center;gap:52px;padding-right:52px;")}>
            {(v.connectors ?? []).map((c, i) => (
              <Fragment key={i}>
                {' '}
                <span
                  style={s("display:inline-flex;align-items:center;gap:11px;white-space:nowrap;opacity:.55;filter:grayscale(1);")}
                >
                  {c.logo ? (
                    <>
                      {' '}
                      <span
                        style={s(`width:22px;height:22px;background:url(${c.logo ?? ""}) center/contain no-repeat;flex:0 0 auto;`)}
                      />
                      {' '}
                    </>
                  ) : null}
                  {' '}
                  <span
                    style={s("font-family:'Sofia Pro',sans-serif;font-size:20px;font-weight:700;letter-spacing:-0.02em;color:var(--text);")}
                  >
                    {c.name}
                  </span>
                  {' '}
                </span>
                {' '}
              </Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
